import React, { useMemo } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import "assets/css/dataTable.css";

const ContainerResumen = ({
  showTitle,
  lastcheck,
  filter,
  handleOnChangeFilter,
  actionsMemo,
  columns,
  dataFiltered,
  PaginationOptions,
  dataEstado,
  errors,
}) => {
  const stats = useMemo(() => {
    const empresas = new Set();
    let totalDias = 0;
    let countDias = 0;
    dataFiltered.forEach((d) => {
      if (d.empresa) empresas.add(d.empresa);
      if (typeof d.dias === "number") {
        totalDias += d.dias;
        countDias += 1;
      }
    });
    return {
      dispositivos: dataEstado ? errors : 0,
      empresas: empresas.size,
      promedioDias: countDias > 0 ? Math.round(totalDias / countDias) : 0,
    };
  }, [dataFiltered, dataEstado, errors]);

  return (
    <Container fluid className="page-container">
      <div className="page-header">
        <div>
          <h2 className="page-title">{showTitle}</h2>
          <p className="page-subtitle">
            Última actualización: {lastcheck || "—"}
          </p>
        </div>
      </div>

      <Row className="stats-row">
        <Col xs={12} sm={6} lg={4}>
          <div className="stat-card stat-card--danger">
            <div className="stat-card__icon">
              <i className="nc-icon nc-vector" />
            </div>
            <div className="stat-card__content">
              <span className="stat-card__label">Dispositivos desconectados</span>
              <span className="stat-card__value">{stats.dispositivos}</span>
            </div>
          </div>
        </Col>
        <Col xs={12} sm={6} lg={4}>
          <div className="stat-card stat-card--info">
            <div className="stat-card__icon">
              <i className="nc-icon nc-paper-2" />
            </div>
            <div className="stat-card__content">
              <span className="stat-card__label">Empresas afectadas</span>
              <span className="stat-card__value">{stats.empresas}</span>
            </div>
          </div>
        </Col>
        <Col xs={12} sm={6} lg={4}>
          <div className="stat-card stat-card--warning">
            <div className="stat-card__icon">
              <i className="nc-icon nc-time-alarm" />
            </div>
            <div className="stat-card__content">
              <span className="stat-card__label">Promedio días desconexión</span>
              <span className="stat-card__value">{stats.promedioDias}</span>
            </div>
          </div>
        </Col>
      </Row>

      <Card className="data-card">
        <Card.Body>
          <div className="data-card__toolbar">
            <div className="search-input">
              <i className="nc-icon nc-zoom-split" />
              <input
                type="text"
                name="search"
                value={filter}
                autoComplete="off"
                placeholder="Filtrar por rut, empresa, dispositivo..."
                onChange={handleOnChangeFilter}
              />
            </div>
            <Button className="btn-export" onClick={actionsMemo.onExport}>
              <i className="nc-icon nc-cloud-download-93" />
              Exportar CSV
            </Button>
          </div>
          <DataTable
            className="-striped -highlight"
            fixedHeader={true}
            columns={columns}
            data={dataFiltered}
            pagination={true}
            paginationComponentOptions={PaginationOptions}
            actionsMemo={actionsMemo}
          />
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ContainerResumen;
